import type { CampaignsFilters } from '../types/campaigns.types';

export const DEFAULT_CAMPAIGNS_FILTERS: CampaignsFilters = {
  statuses: [],
  channel: 'all',
};
